import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HeadlineSectionComponent} from '../headline-section/headline-section.component';
import {LogoAreaComponent} from '../logo-area/logo-area.component';
import {CldatePipe} from '../../pipes/cldate.pipe';
import {ChangelogEntry, WhatsNewService} from '../../services/whats-new.service';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrl: './whats-new.component.scss',
  imports: [HeadlineSectionComponent, LogoAreaComponent, CldatePipe]
})
export class WhatsNewComponent implements OnInit {
  protected loading = true;
  protected entries: ChangelogEntry[] = [];

  constructor(private whatsNew: WhatsNewService, private router: Router) {}

  ngOnInit(): void {
    // Bundled at deploy time by scripts/generate_changelog.py from the GitHub
    // Releases of this environment's channel. Newest deploy first.
    this.whatsNew.load().subscribe(entries => {
      this.entries = entries;
      this.loading = false;
      this.whatsNew.markSeen();
    });
  }

  /**
   * Closes the popover outlet only. The primary outlet keeps whatever the user
   * deep-linked to, so dismissing reveals that page instead of navigating away.
   */
  protected dismiss(): void {
    this.router.navigate([{outlets: {overlay: null}}], {queryParamsHandling: 'preserve'});
  }
}